import { Navigation } from "./navigation";

export const NavigationContainer = () => {
  return <Navigation />;
};
